import { useCallback } from 'react';
import { CULTURE_TOKEN } from '@servicetitan/culture';
import { useDependencies } from '@servicetitan/react-ioc';
const emptyFormatInfo = {
    Pattern: undefined,
    Format: undefined,
};
export const useFormatPhone = () => {
    var _a;
    const [cultureStore] = useDependencies(CULTURE_TOKEN);
    const { PhoneFormatInfo = emptyFormatInfo, PhoneWithExtNumberFormatInfo = emptyFormatInfo } = (_a = cultureStore.PhoneFormat) !== null && _a !== void 0 ? _a : {};
    const { Pattern, Format } = PhoneFormatInfo;
    const { Pattern: patternWithExt, Format: formatWithExt } = PhoneWithExtNumberFormatInfo;
    return useCallback((phoneNumber) => {
        if (!phoneNumber || phoneNumber.startsWith('sip')) {
            return phoneNumber;
        }
        const [pattern, format] = phoneNumber.length > 10 ? [patternWithExt, formatWithExt] : [Pattern, Format];
        if (pattern && format) {
            return phoneNumber.replace(pattern, format);
        }
        return phoneNumber;
    }, [Pattern, Format, patternWithExt, formatWithExt]);
};
//# sourceMappingURL=use-format-phone.js.map